$(document)
  .on('click', '[data-header-search-toggle]', () => {
    $('[data-header-search-toggle]')
      .hide();
    $('[data-header-search]')
      .show();
    $('[data-instant-search]')
      .focus();
  });

$(document)
  .on('click', (event) => {
    const target = $(event.target);
    if (!target.closest('[data-header-search], [data-header-search-toggle]').length) {
      $('[data-header-search-toggle]')
        .show();
      $('[data-header-search]')
        .hide();
    }
  });


$(document)
  .on('click', '[data-customer-items-preview] button', (event) => {
    event.preventDefault();
    const target = $(event.target).closest('[data-customer-items-preview]');
    target.toggleClass('shopitem__customer-items--preview');
  });
